import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, DateRangeValue, DateRangeControl} from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class DateRangeHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const control:DateRangeControl = qc.control as DateRangeControl;
    const arr = [];
    const drv = (qc.value as DateRangeValue);
    drv.startTime && arr.push({
      'FilterField': control.startFieldCode ? control.startFieldCode : qc.fieldCode,
      'Compare': CompareType.GreaterOrEqual, // GreaterOrEqual
      'Value': drv.startTime,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });
    drv.endTime && arr.push({
      'FilterField': control.endFieldCode ? control.endFieldCode : qc.fieldCode,
      'Compare': CompareType.LessOrEqual, // LessOrEqual
      'Value': drv.endTime,
      'Relation': RelationType.And, // and
      'Expresstype': ValueType.Value
    });

    return arr;
  }
}
